const ONCE_NOW = 'once_now';
const ONCE_LATER = 'once_later';
const AS_MET = 'as_met';

const VALUE_TO_LABEL = {
    [ONCE_NOW]: 'Once Now',
    [ONCE_LATER]: 'Once Later',
    [AS_MET]: 'As Criteria Is Met'
};

module.exports = Object.freeze({
    ONCE_NOW: ONCE_NOW,

    ONCE_LATER: ONCE_LATER,

    AS_MET: AS_MET,

    SCHEDULING_OPTIONS: [
        {
            label: VALUE_TO_LABEL[ONCE_NOW],
            value: ONCE_NOW,
        },
        {
            label: VALUE_TO_LABEL[ONCE_LATER],
            value: ONCE_LATER,
        },
        {
            label: VALUE_TO_LABEL[AS_MET],
            value: AS_MET,
        }
    ],

    valueToLabel: function (value) {
        return VALUE_TO_LABEL[value];
    },
});
